module.exports = __webpack_public_path__ + "static/media/Euro.c219b471.png";